// src/utils/utils_devicePurchase.ts
// Point d'entrée unique de l'action « Acheter des devices ».
//
// La mécanique (choix du palier si plusieurs sont actifs, ajout au panier, ouverture
// directe du paiement) est partagée entre les 5 ressources CreatorCapacity — voir
// utils_creatorCapacityPurchase.ts. Seule cette fonction est à modifier si le point
// d'entrée change — tous les appelants suivront.

import { buyCreatorCapacity }  from "./utils_creatorCapacityPurchase";

export const BUY_DEVICES_LABEL = 'Acheter des devices';

/**
 * @param notify  Fonction d'affichage du message. Par défaut window.alert ;
 *                les écrans disposant d'une fenêtre applicative (régie…) passent la leur.
 */
export async function openBuyDevices(
  notify: (message: string) => void = (message) => window.alert(message)
): Promise<void> {
  return buyCreatorCapacity(
    'devices',
    "L'achat d'appareils supplémentaires n'est pas encore disponible.",
    '+ de devices',
    notify
  );
}
